import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import avatarUpload from "components/avatarUpload.vue";
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import Bus from "components/bus.js";
import newLogin from "components/newLogin.vue";
export default {
  data: function data() {
    return {
      urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      form: {
        avatar: "",
        name: "",
        school: "",
        IDNum: "",
        sex: "",
        post: "",
        phoneNum: "",
        email: "",
        address: "",
        invoice: "",
        payTaxes: "",
        liveWay: "",
        payWay: "",
        notes: ""
      },
      timer: "",
      IsTipsDialog: true,
      showObject: {
        isShow: false
      },
      isSubmit: false,
      rules: {
        name: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }]
      },
      showTip: true
    };
  },
  props: {
    signUpId: {
      type: String,
      default: ""
    },
    planId: {
      type: String,
      default: ""
    }
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.auth;
    },
    association: function association() {
      return this.$store.state.association;
    },
    target: function target() {
      var Urlname = "";

      if (this.$store.state.auth.userType === 1) {
        Urlname = "stuBasicInfo";
      } else if (this.$store.state.auth.userType === 2) {
        Urlname = "teaPilotManager";
      } else if (this.$store.state.auth.userType === 3) {
        Urlname = "siteBasicInfo";
      } else if (this.$store.state.auth.userType === 9) {
        Urlname = "systemManager";
      }

      return {
        name: Urlname
      };
    }
  },
  components: {
    avatarUpload: avatarUpload,
    newLogin: newLogin
  },
  created: function created() {},
  methods: {
    fanhui: function fanhui() {
      this.$router.go(-1);
    },
    submitTable: function submitTable(formName) {
      var _this = this;

      var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;

      if (this.form.name == "") {
        this.$message({
          message: "请输入姓名",
          type: "warning"
        });
        return false;
      }

      if (this.form.sex === "") {
        this.$message({
          message: "请选择性别",
          type: "warning"
        });
        return false;
      }

      if (this.form.phoneNum == "") {
        this.$message({
          message: "请输入号码",
          type: "warning"
        });
        return false;
      } else if (!reg.test(this.form.phoneNum)) {
        this.$message({
          message: "手机号格式不正确",
          type: "warning"
        });
        return false;
      }

      if (this.form.email == "") {
        this.$message({
          message: "请输入邮箱",
          type: "warning"
        });
        return false;
      }

      if (this.form.school == "") {
        this.$message({
          message: "请输入单位",
          type: "warning"
        });
        return false;
      }

      if (this.form.invoice == "") {
        this.$message({
          message: "请输入发票抬头",
          type: "warning"
        });
        return false;
      }

      if (this.form.avatar == "") {
        this.$message({
          message: "请上传头像",
          type: "warning"
        });
        return false;
      }

      if (this.form.payTaxes == "") {
        this.$message({
          message: "请输入纳税人识别号",
          type: "warning"
        });
        return false;
      }

      if (this.form.IDNum == "") {
        this.$message({
          message: "请输入身份证号",
          type: "warning"
        });
        return false;
      }

      if (this.form.post == "") {
        this.$message({
          message: "请输入职务",
          type: "warning"
        });
        return false;
      }

      if (this.form.address == "") {
        this.$message({
          message: "请输入地址",
          type: "warning"
        });
        return false;
      }

      if (this.form.liveWay == "") {
        this.$message({
          message: "请选择单/合住",
          type: "warning"
        });
        return false;
      }

      if (this.form.payWay == "") {
        this.$message({
          message: "请选择付款方式",
          type: "warning"
        });
        return false;
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.isSubmit = true;

          _this.$http.post("/api/XOrg/PeiXun/addPeiXun", {
            activityId: _this.signUpId,
            planId: _this.planId,
            Name: _this.form.name,
            Sex: _this.form.sex,
            IDNum: _this.form.IDNum,
            SchoolTitle: _this.form.school,
            Photo: _this.form.avatar,
            Post: _this.form.post,
            Phone: _this.form.phoneNum,
            Email: _this.form.email,
            Address: _this.form.address,
            Invoice: _this.form.invoice,
            TaxNumber: _this.form.payTaxes,
            PaymentType: _this.form.payWay,
            StayType: _this.form.liveWay,
            Note: _this.form.notes
          }).then(function (res) {
            if (res.code > 0) {
              var h = _this.$createElement;

              _this.$message({
                message: h("div", null, [h("p", null, [h("span", {
                  style: "color: #000"
                }, "报名成功，可登陆"), h("span", {
                  style: "color: red"
                }, res.username), h("span", {
                  style: "color: #000"
                }, "账号进行修改管理")]), h("p", null, [h("span", {
                  style: "color: #000"
                }, "默认密码为手机号后六位"), h("span", {
                  style: "color: red"
                }, res.password), h("span", {
                  style: "color: #000"
                }, "即将跳转到管理系统...")])]),
                type: "success",
                duration: 5000
              });

              _this.timer = setTimeout(_this.goclpp, 5000);
            } else {
              _this.isSubmit = false;

              _this.$message({
                message: res.msg,
                type: "warning"
              });
            }
          });
        } else {
          _this.$message({
            message: res.msg,
            type: "warning"
          });

          return false;
        }
      });
    },
    goclpp: function goclpp() {
      this.$router.push({
        name: "TeaPeiXunEnrollManager"
      });
    },
    Gologin: function Gologin() {
      this.IsTipsDialog = false;
      this.showObject = {
        isShow: true
      };
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};